import React from "react";
import styles from "./CustomerSupport.module.css";

const supportOptions = [
  { title: "Technical Support", icon: "🛠", description: "Get help with bugs, glitches, or tech-related issues." },
  { title: "Billing and Payments", icon: "💳", description: "Get help with bugs, glitches, or tech-related issues." },
  { title: "Account Settings", icon: "⚙️", description: "Get help with bugs, glitches, or tech-related issues." },
  { title: "AI voice setup", icon: "🎙", description: "Get help with bugs, glitches, or tech-related issues." },
  { title: "Getting Started", icon: "🚀", description: "Get help with bugs, glitches, or tech-related issues." },
  { title: "Contact Support", icon: "📞", description: "Get help with bugs, glitches, or tech-related issues." }
];

const CustomerSupport = () => {
  return (
    <div className={styles.container}>
      <div className={styles.containertop}>
      <h1 className={styles.title}>Welcome to ToxBox help</h1>
      <p className={styles.subtitle}>
        Find answers, troubleshoot issues, or talk to our AI assistant – we're here to help you every step of the way.
      </p>
      <div className={styles.searchWrapper}>
        <input className={styles.searchInput} placeholder="Search" />
        <button className={styles.searchButton}>🔍</button>
      </div>
      </div>

      <h2 className={styles.sectionTitle}>Resources</h2>
      <div className={styles.grid}>
        {supportOptions.map((item, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.icon}>{item.icon}</div>
            <h3 className={styles.cardTitle}>{item.title}</h3>
            <p className={styles.cardText}>{item.description}</p>
          </div>
        ))}
      </div>

      <h2 className={styles.sectionTitle}>Contact Us</h2>
      <div className={styles.contactBox}>
        <h3>Can’t find what you are looking for?</h3>
        <p>
          Whether you have questions about your AI assistant setup, billing issues, or anything in between, we're here to
          support you.
        </p>
        <div className={styles.buttonGroup}>
          <button className={styles.primaryButton}>Chat with AI Assistant</button>
          <button className={styles.outlineButton}>Chat with AI Assistant</button>
        </div>
      </div>
    </div>
  );
};

export default CustomerSupport;
